<template>
  <div class="__C_PageTitle">
    <div class="__C_PageTitle-Content">
      <div v-show="backable" @click="$emit('back')">
        <CButton class="mr-sm" icon="arrow_back" round />
      </div>

      <div>
        <div class="__C_PageTitle-Title">
          <!-- Title Slot -->
          <slot />

          <!-- Title Props -->
          <span class="__C_PageTitle-TitleText" v-if="!$slots.default">
            {{ title }}
          </span>

          <CBadge :color="badgeColor" align="top" v-if="badgeText">{{ badgeText }}</CBadge>
        </div>

        <div class="__C_PageTitle-Description">
          <!-- Description Slot -->
          <slot name="description" />

          <!-- Description Props -->
          <span class="__C_PageTitle-DescriptionText" v-if="!$slots.description">
            {{ description }}
          </span>
        </div>
      </div>
    </div>

    <div class="__C_PageTitle-RightContent">
      <slot name="right-content" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CButton from '@/components/uikit/CButton';
import CBadge from '@/components/uikit/CBadge';

export default Vue.extend({
  name: 'CPageTitle',
  components: { CButton, CBadge },
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    backable: {
      type: Boolean,
    },
    // Badge
    badgeText: { type: String },
    badgeColor: { type: String, default: 'primary' },
  },
});
</script>

<style lang="scss" scoped>
.__C_PageTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: $margin-md;

  &-Content {
    display: flex;
    align-items: center;
  }

  &-TitleText {
    font-size: $font-size-lg;
    font-weight: $font-weight-bold;
  }

  &-DescriptionText {
    font-size: $font-size-md;
  }

  &-RightContent {
  }
}
</style>
